/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import PillButton from '../buttons/Pill';
import Arrow from '../icons/Arrow';
import Image from '../partials/Image';

import styles from '../../../styles/headers/article.module.scss';

const propTypes = {
    image: AppPropTypes.image,
    title: PropTypes.string,
    onButtonClick: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    image: null,
    title: null,
    onButtonClick: null,
    className: null,
};

const ArticleHeader = ({ image, title, onButtonClick, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        <Image media={image} className={styles.imageContainer} imageClassName={styles.image} />
        <div className={styles.bottomContainer}>
            <div className={styles.bottom}>
                <h1 className={styles.title}>{title}</h1>
                {onButtonClick !== null ? (
                    <PillButton
                        className={styles.button}
                        onClick={onButtonClick}
                        icon={<Arrow direction="bottom" />}
                    />
                ) : null}
            </div>
        </div>
    </div>
);
ArticleHeader.propTypes = propTypes;
ArticleHeader.defaultProps = defaultProps;

export default ArticleHeader;
